import React, {useEffect, useState} from "react";
import {IncomingCreateType} from "./interface";
import {incomingCreateInit} from "./state";
import {useCreateIncomingCode} from "./hooks/useCreateInventoryBarcode";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import {useModal} from "../../../../hooks";
import {useUser} from "../../../../util/userContext/UserContext";
import moment from "moment";
import {useCreateIncoming} from "./hooks/useCreateIncoming";
import FileUploadNoText from "../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import {useUploadIncomingExcel} from "./hooks/useUploadIncomingExcel";
import EmptyTableRow from "../../../common/EmptyTableRow";
import SearchInventoryInner from "../../../../components/common/modal/inner/SearchInventoryInner";
import ScanBarcodeInner from "../../../../components/common/modal/inner/ScanBarcodeInner";
import {SearchBusinessPartnerInner} from "../../../../components/common/modal/inner/SearchBusinessPartnerInner";
import {useLocation} from "react-router-dom";
import {InvDetailType} from "../../inv/detail/interface";
import InputNumberUc from "../../../../components/common/number/InputNumberUc";
import DisplayNumber from "../../../../components/common/number/DisplayNumber";

export default function IncomingCreate() {
    const {state} = useLocation() as { state: { invDetail: InvDetailType } };
    const invDetail = state?.invDetail;
    const {handleModal} = useModal();

    const {user} = useUser();
    const {data: incomingCode} = useCreateIncomingCode()
    const {mutate: mutateCreateIncoming} = useCreateIncoming()
    const {mutateAsync: mutateAsyncUploadIncomingExcel} = useUploadIncomingExcel()

    const [createData, setCreateData] = useState<IncomingCreateType>((() => ({
        ...incomingCreateInit,
        changeAt: moment().format("YYYY-MM-DD"),
    }))())

    const {register, handleSubmit, getValues, control, setValue, watch} = useForm({
        defaultValues: createData,
    });

    const watchCreateData = {
        ...createData,
        ...useWatch<IncomingCreateType>({control}),
    };

    useEffect(() => {
        if (invDetail) {
            setValue("createEachIncomingReqList", [{
                ...invDetail,
                changeAmount: 1,
            }]);
        }
    }, []);

    const onSubmit: SubmitHandler<IncomingCreateType> = (submitData) => {
        if (getValues("createEachIncomingReqList").length === 0) {
            handleModal({
                isOpen: true,
                contents: "입고 품목을 추가해주세요.",
                type: "alert"
            })
        } else {
            mutateCreateIncoming({...submitData, code: incomingCode})
        }
    };

    const btnImportExcel = (file: File[]) => {
        if (file.length === 0) {
            handleModal({
                isOpen: true,
                contents: "파일을 선택해주세요.",
                type: "alert"
            })
        } else {
            const fd = new FormData()
            fd.append("excelFile", file.at(0) as File)

            mutateAsyncUploadIncomingExcel(fd).then((res: any) => {
                if (res.data.code === "0000") {
                    const list = res.data.result
                    console.log("excel list result : ", list);

                    if (
                        getValues("createEachIncomingReqList").some(el => list.map((el2: any) => el2.inventoryId).includes(el.inventoryId))
                    ) {
                        handleModal({
                            isOpen: true,
                            contents: "중복된 품목은 추가할 수 없습니다.",
                            type: "alert",
                        });
                    } else {
                        setValue("createEachIncomingReqList", [...getValues("createEachIncomingReqList"), ...list.map((el: any) => ({
                            ...el,
                            // changeAmount: 0
                        }))])
                    }
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.message ?? res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    }

    const btnShowScanBarcodeInterface = () => {
        handleModal({
            isOpen: true,
            contents: <ScanBarcodeInner
                value={getValues("createEachIncomingReqList")}
                setValue={(data) => setValue("createEachIncomingReqList", data)}
            />,
            type: "",
            title: "바코드 스캔"
        });
    }

    const btnAdd = () => {
        handleModal({
            isOpen: true,
            contents: <SearchInventoryInner
                confirmCallback={(item) => {
                    setValue("createEachIncomingReqList", [...getValues("createEachIncomingReqList"), {
                        ...item,
                        changeAmount: 1
                    }])
                }}
                modalDepth={1}
            />,
            type: "",
            title: "재고 조회",
            modalSize: "xl",
        });
    }

    const btnSearchAccountName = () => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchBusinessPartnerInner
                    confirmCallback={(item) => {
                        if (setValue) {
                            setValue("accountName", item?.name, {
                                shouldDirty: true,
                            });
                        }
                    }}
                    modalDepth={1}
                />
            ), type: "",
            title: "상위 거래처 조회",
            modalSize: "xxl",
        });
    }

    const removeItem = (index: number) => {
        setValue("createEachIncomingReqList", getValues("createEachIncomingReqList").filter((_, i) => i !== index));
    };

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">입고 등록</h3>
            <div className="filter_toolbar">
                {/* NOTE: 목록 버튼이 필요 없어 보여서 삭제 */}
                {/*<button className="btn btn-outline-primary w-100px h-38px">*/}
                {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록*/}
                {/*</button>*/}
                <button className="btn btn-primary w-100px h-38px" onClick={handleSubmit(onSubmit)}>등록</button>
            </div>
        </div>

        <h5 className="subheading">입고 정보</h5>
        <table className="table table-bordered my_table">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>입고번호</th>
                <td colSpan={3}>{incomingCode ?? ""}</td>
            </tr>
            <tr>
                <th style={{width: "16.66%"}}>생성자</th>
                <td style={{width: "33.3%"}}>{user?.userName ?? ""}</td>
                <th style={{width: "16.66%"}}>생성일자</th>
                <td>{moment().format("YYYY-MM-DD")}</td>
            </tr>
            <tr>
                <th>입고처</th>
                <td className="p-4px">
                    <div className="d-flex">
                        <input type="text" className="form-control"
                               value={watchCreateData.accountName}
                               {...register("accountName")}
                        />
                    </div>
                </td>
                <th>입고일자</th>
                <td className="p-4px">
                    <input
                        type="date"
                        className="form-control"
                        max="9999-12-31"
                        value={watchCreateData.changeAt}
                        {...register("changeAt")}
                    />
                </td>
            </tr>
            <tr>
                <th>메모</th>
                <td className="p-4px" colSpan={3}>
                    <input type="text" className="form-control"
                           value={watchCreateData.memo}
                           {...register("memo")}
                    />
                </td>
            </tr>
            </tbody>
        </table>

        <div className="table_top mb-10px align-items-end">
            <h6 className="table_stats">입고 품목</h6>
            <div className="table_toolbar">
                <FileUploadNoText
                    addFileCallback={(file: File[]) => btnImportExcel(file)}
                    customRenderer={(onClick: any, disabled: any) =>
                        <button className="btn btn-outline-dark w-150px px-0"
                                onClick={onClick}
                                disabled={disabled}><img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt=""/>엑셀 가져오기
                        </button>

                    }
                    accept={".xlsx, .xls"}
                />
                <button className="btn btn-primary w-100px px-0 ms-40px" onClick={btnShowScanBarcodeInterface}>바코드 스캔
                </button>
                <button className="btn btn-dark w-100px px-0" onClick={btnAdd}>추가</button>
            </div>
        </div>

        <table className="table table-bordered my_table mb-0">
            <thead>
            <tr>
                <th style={{width: "5%"}}></th>
                <th style={{width: "10.06%"}}>벤더</th>
                <th style={{width: "10.06%"}}>카테고리</th>
                <th style={{width: "24.5%"}}>품목</th>
                <th style={{width: "13.83%"}}>규격</th>
                <th style={{width: "13.83%"}}>단위</th>
                <th style={{width: "13.83%"}}>입고 수량</th>
                <th>현재재고</th>
            </tr>
            </thead>
            <tbody>
            {watchCreateData.createEachIncomingReqList.length !== 0
                ? watchCreateData.createEachIncomingReqList.map((el, idx) =>
                    <tr>
                        <td className="text-center">
                            <button className="btn btn-link p-0" onClick={() => removeItem(idx)}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_btn_delete.png"}
                                     alt=""/>
                            </button>
                        </td>
                        <td className="text-center">{el.vendor}</td>
                        <td className="text-center">{el.category}</td>
                        <td className="text-center">{el.newTxtNmItem}</td>
                        <td className="text-center">{el.newTxtStndItem}</td>
                        <td className="text-center">{el.inventoryUnit}</td>
                        <td className="p-4px">
                            <InputNumberUc control={control} name={`createEachIncomingReqList.${idx}.changeAmount`}/>
                            {/*<input type="text"
                                   className="form-control text-center"
                                   value={el.changeAmount}
                                   {...register(`createEachIncomingReqList.${idx}.changeAmount`)}
                            />*/}
                        </td>
                        <td className="text-center"><DisplayNumber value={el.inventoryAmount ?? 0}/></td>
                    </tr>
                )
                : <EmptyTableRow colSpan={7} msg={"입고 품목을 추가해주세요."}/>}
            <tr className="blue">
                <td className="text-center" colSpan={5}>품목 수</td>
                <td className="text-end">{watchCreateData.createEachIncomingReqList.length}</td>
                <td className="text-center">총 수량</td>
                <td className="text-center">
                    {isNaN(watchCreateData.createEachIncomingReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0))
                        ? <>-</>
                        : <span
                            className={watchCreateData.createEachIncomingReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0) < 0 ? "required" : "requiredBlue"}>
                        {watchCreateData.createEachIncomingReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0) > 0 && <>+</>}
                            <DisplayNumber
                                value={watchCreateData.createEachIncomingReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0)}/>
                    </span>
                    }
                </td>
            </tr>
            </tbody>
        </table>
    </div>
}